import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d470aa1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "engineer-status-container f1 fv" }
const _hoisted_2 = {
  class: "fh-s-b",
  style: {"height":"8.33%"}
}
const _hoisted_3 = { class: "fh-c" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs16 color-06 bold" }, "满意度评价", -1))
const _hoisted_5 = {
  class: "f1",
  style: {"height":"calc(81.67% - 16px)","margin-top":"16px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("5分")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("4分")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("3分")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("2分")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("1分")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("未评分")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menuItem = _resolveComponent("a-menuItem")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_VirtualColumnVue = _resolveComponent("VirtualColumnVue")!
  const _component_VirtualTableVue = _resolveComponent("VirtualTableVue")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("a", {
            class: "fs12 color-primary",
            style: {"margin-left":"4px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
          }, "设置")
        ]),
        _createVNode(_component_a_dropdown, { style: {"width":"200px"} }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, { class: "menu" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_menuItem, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTime('THIS_DAY')))
                    }, "今日")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menuItem, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTime('THIS_WEEK')))
                    }, "本周")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menuItem, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTime('THIS_MONTH')))
                    }, "本月")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("a", {
              class: "fs12 color-primary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, _toDisplayString(_ctx.timeFilter(_ctx.timeRef)), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_VirtualTableVue, {
          data: _ctx.data,
          openVirtual: "",
          style: {"width":"100%","height":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VirtualColumnVue, {
              prop: "ticketNo",
              width: "88",
              label: "工单编号"
            }),
            _createVNode(_component_VirtualColumnVue, {
              prop: "userName",
              width: "68",
              label: "客户"
            }),
            _createVNode(_component_VirtualColumnVue, {
              prop: "engineerName",
              width: "68",
              label: "客服"
            }),
            _createVNode(_component_VirtualColumnVue, {
              prop: "serviceDeskName",
              width: "88",
              label: "客户组"
            }),
            _createVNode(_component_VirtualColumnVue, {
              prop: "evaluateScore",
              width: "88",
              label: "满意度评分"
            }, {
              default: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString((data.evaluateScore ?? '未评') + '分'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
      title: "评价数据设置",
      onOk: _ctx.setScore,
      "ok-text": "确定",
      "cancel-text": "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_select, {
          value: _ctx.scoreRef,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.scoreRef) = $event)),
          mode: "multiple",
          style: {"width":"100%"},
          placeholder: "请选择",
          "allow-clear": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: 5 }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 4 }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 3 }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 2 }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 1 }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: -1 }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}